module.exports = __webpack_public_path__ + "img/p20.4ccee3c1.jpg";